export default "__VITE_ASSET__CbsUp5Sd__"